import { useMutation } from "react-query";
import { MedicalExaminationService } from "@services/medical-examination.service";

export const useDownloadMedicalExamsEmployeesListMutation = () => {
  return useMutation(MedicalExaminationService.downloadEmployeesList);
};
